"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bar = exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../../../theme"));
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"])));
exports.MainContainer = MainContainer;
var Bar = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 3px;\n  background: ", ";\n  background-size: 200% 100%;\n  background-position: ", ";\n  transition: all 0.3s ease-out;\n\n  ", "\n"], ["\n  height: 3px;\n  background: ", ";\n  background-size: 200% 100%;\n  background-position: ", ";\n  transition: all 0.3s ease-out;\n\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return "linear-gradient(to right, ".concat(color || theme_1.default.colorsPalette.blue.default, " 50%, ").concat(theme_1.default.colorsPalette.gray.lighter, " 50%)");
}, function (_a) {
    var active = _a.active, completed = _a.completed;
    return active || completed ? "left bottom" : "right bottom";
}, function (_a) {
    var position = _a.position;
    var styles = "";
    if (position === "first") {
        styles = "\n            border-top-left-radius: 5px;\n            border-bottom-left-radius: 5px;\n          ";
    }
    if (position === "last") {
        styles += "\n            border-top-right-radius: 5px;\n            border-bottom-right-radius: 5px;\n          ";
    }
    return styles;
});
exports.Bar = Bar;
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map